import { useCallback } from 'react'
import { useCreateApiNotification, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'

export const useMergeRoles = (getRoles: () => {}) => {
  const [request] = useFetchRefactored<{ id: number }[]>({
    emptyValue: undefined,
  })

  const createNotification: any = useCreateApiNotification()
  const organization = useCurrentOrg()

  return useCallback(
    async (roles: any[], name: string) => {
      const notification = createNotification('Merging roles')
      try {
        // @ts-ignore
        await request({
          method: 'post',
          url: `/organizations/${organization.id}/roles/merges`,
          config: {
            body: {
              replacedRoleIds: roles.map(({ id }) => id),
              name,
            },
          },
        })

        await getRoles()

        notification.onSuccess('Roles merged!')
      } catch (error) {
        notification.onError(`Could not merge roles`, error)
      }
    },
    [createNotification, getRoles, organization.id, request],
  )
}

export default useMergeRoles
